import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Text';
import { H2 } from 'components/core/Typography';

export const enhance = (Component) => (props) => {
	const { totalItems, hideIfEmpty, page, itemsPerPage, ...rest } = props;

	if (!totalItems && !!hideIfEmpty) {
		return null;
	}

	const { start, end } = useMemo(() => ({
		start: (page - 1) * itemsPerPage + 1,
		end: Math.min(page * itemsPerPage, totalItems),
	}), [page, itemsPerPage, totalItems]);

	return <Component {...rest} totalItems={totalItems} start={start} end={end} />;
};

export function PaginationSummary({
	start = 0,
	end = 0,
	totalItems = 0,
	label = '',
	prefix = '',
	strong = true,
	isDot,
	isNearMePage,
}) {
	return !totalItems ? (
		<Text
			className="pagination-summary"
			strong={strong}
		>
			0 {label}
		</Text>
	) : (
		<H2 className="pagination-summary">
			{!!prefix &&
				(isNearMePage
					? `${start} - ${end} of ${totalItems} ${label.trim()} Near You`
					: `${start} - ${end} of ${totalItems} ${label.trim()} ${label.trim() === 'reviews' ? 'is' : 'in'} ${prefix}`)}
		</H2>
	);
}

PaginationSummary.propTypes = {
	label: PropTypes.string,
	totalItems: PropTypes.number,
	start: PropTypes.number,
	end: PropTypes.number,
	prefix: PropTypes.string,
	strong: PropTypes.bool,
	isDot: PropTypes.bool,
};

export default enhance(PaginationSummary);
